import { DebitCardProductCode } from '@/types/card';

import { Card, CardType } from '@generated-types';

import { BUSINESS_CREDIT_CARD_PRODUCTS } from './constants/card';

export const isCredit = (card: Card) => card.type === CardType.CREDIT;

export const isCreditCardType = (cardType: CardType) => cardType === CardType.CREDIT;

export const isDebit = (card: Card) => card.type === CardType.DEBIT;

export const isChildCard = ({ product }: Card) =>
    product.key === DebitCardProductCode.BANKKORT_BARN || product.key === DebitCardProductCode.BANKKORT_BARN_DEPRECATED;

export const isTeenagerCard = ({ product }: Card) =>
    product.key === DebitCardProductCode.BANKKORT_UNG_M_BILDE ||
    product.key === DebitCardProductCode.BANKKORT_UNG ||
    product.key === DebitCardProductCode.BANKKORT_UNG_M_BILDE_DEPRECATED ||
    product.key === DebitCardProductCode.BANKKORT_UNG_DEPRECATED;

export const isAdultCard = (card: Card) => !isChildCard(card) && !isTeenagerCard(card);

export const isBusinessCard = ({ product }: Card): boolean =>
    typeof product.id !== 'undefined' && BUSINESS_CREDIT_CARD_PRODUCTS.includes(product.id);
